import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['banner', 'nav']

  static values = {
    cookieName: { type: String, default: 'bodyos_prelaunch_banner_dismissed' }
  }

  dismiss() {
    // Set cookie for 1 year so server can read it on next page load
    document.cookie = `${this.cookieNameValue}=true; path=/; max-age=31536000; SameSite=Lax`
    this.hide()
  }

  hide() {
    if (this.hasBannerTarget) {
      this.bannerTarget.classList.add('hidden')
    }
    if (this.hasNavTarget) {
      this.navTarget.classList.remove('top-12')
      this.navTarget.classList.add('top-0')
    }
  }
}
